import { Component, Input, OnInit } from '@angular/core';
import { HLDisplayAvailabilityReport, HlDisplayAvailabilityReportService } from '../../services/hl-display-availability-report.service';
import { first } from 'rxjs';

@Component({
  selector: 'hl-display-availability-report',
  templateUrl: './hl-display-availability-report.component.html',
  styleUrl: './hl-display-availability-report.component.css',
  standalone: false
})
export class HlDisplayAvailabilityReportComponent {

  @Input() productId: string;

  availabilityReport: HLDisplayAvailabilityReport;

  constructor(private hlDisplayAvailabilityReportService: HlDisplayAvailabilityReportService) {}

  generateAvailabilityReport(): void {
    this.hlDisplayAvailabilityReportService.getAvailabilityReport(this.productId).pipe(first()).subscribe(report => {
      this.availabilityReport = report;
    });
  }
}
